import { PipeTransform, Pipe } from '@angular/core';

@Pipe({ name: 'currency' })
export class CurrencyPipe implements PipeTransform {
  constructor() {
  }

  transform(value) {
    return value ? `${value.toLocaleString()}₫` : '0₫';
  }
}
